import { render, staticRenderFns } from "./sinDatos.vue?vue&type=template&id=4c4032b6&scoped=true"
import script from "./sinDatos.vue?vue&type=script&lang=js"
export * from "./sinDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4032b6",
  null
  
)

export default component.exports